import { useAppSelector } from '../../shared/config/store'

export const getDropzoneOptionsSelector = () => useAppSelector(state => state.dropzone.dropzoneOptions)

export const getIsDropzoneAreaVisibleSelector = () => useAppSelector(state => state.dropzone.isDropzoneAreaVisible)

export const getDropzoneLocalAvailableExtensionsSelector = () => useAppSelector(state => state.dropzone.localAvailableExtensions)
